
import NavBar from "./NavBar";
import Footer from "./Footer";
import { useEffect, useState } from "react";
import './Contact.css';

function Contact() {

    const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const [errors, setErrors] = useState({});

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[0-9+\-\s]{7,15}$/;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
  e.preventDefault();

  let newErrors = {};

  if (!formData.name.trim()) newErrors.name = "Name is required.";
  if (!emailRegex.test(formData.email)) newErrors.email = "Enter a valid email.";
  if (!phoneRegex.test(formData.phone)) newErrors.phone = "Enter a valid phone number.";
  if (!formData.message.trim()) newErrors.message = "Message cannot be empty.";

  setErrors(newErrors);

  
  if (Object.keys(newErrors).length === 0) {
    fetch("https://formspree.io/f/xeaqppyg", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    })
      .then(res => res.json())
      .then(data => {
        alert("Message sent successfully!");
      })
      .catch(err => {
        alert("There was an error sending your message.");
      });
  }
};


  return (
    <>
    <div className="contact-page">
    <NavBar currentPage="contact" />
    <section className="contact-section">
      
      <h2 className={`page-header ${visible ? "visible" : ""}`}>
      Get in Touch
    </h2>
     
      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
        />
        {errors.name && <p className="error">{errors.name}</p>}

        <input
          type="email"
          name="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
        />
        {errors.email && <p className="error">{errors.email}</p>}

        <input
          type="text"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
        />
        {errors.phone && <p className="error">{errors.phone}</p>}

        <textarea
          name="message"
          placeholder="Your Message"
          rows="5"
          value={formData.message}
          onChange={handleChange}
        ></textarea>
        {errors.message && <p className="error">{errors.message}</p>}

        <button type="submit" className="contact-submit">Send Message</button>
      </form>
    </section>
       <Footer />
       </div>
       </>
  );
}

export default Contact;

